import { defineStore, acceptHMRUpdate } from 'pinia'
import { STORAGE_KEYS } from '@/libs/utils/constants.ts'
import { executionEsCountType, getUnreadCountSettings } from '@/api/navBar'

export const sideBarStore = defineStore({
  id: STORAGE_KEYS.SIDEBAR_INFO,
  state: () => ({
    componentName: 2,
    barCounts: {},
    barCountSetting: {},
  }),
  getters: {
    getCurrentKey: state => {
      return state.componentName
    },
    getBarCounts: state => {
      return state.barCounts
    },
  },
  actions: {
    setSideBar(newKey) {
      this.componentName = newKey
    },
    async setBarCounts() {
      const res = await executionEsCountType()
      this.barCounts = res?.data ?? {}
    },
    async getBarCountSetting() {
      const res = await getUnreadCountSettings()
      this.barCountSetting = res?.data ?? {}
    },
  },
})
